import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { ACTION, buildEditLinkPayload, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { commandWithMetadata } from '@atlaskit/editor-common/card';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { HyperlinkAddToolbar as HyperlinkToolbar } from '@atlaskit/editor-common/link';
import { linkToolbarMessages } from '@atlaskit/editor-common/messages';
import { LINKPICKER_HEIGHT_IN_PX, RECENT_SEARCH_HEIGHT_IN_PX, RECENT_SEARCH_WIDTH_IN_PX } from '@atlaskit/editor-common/ui';
import { getDatasourceType } from '@atlaskit/editor-common/utils';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { hideLinkToolbar as _hideLinkToolbar, showDatasourceModal, showLinkToolbar } from '../pm-plugins/actions';
import { changeSelectedCardToLink, updateCard } from '../pm-plugins/doc';
import { displayInfoForCard, findCardInfo } from '../utils';
export function HyperlinkAddToolbarWithState(_ref) {
  var _ref$linkPickerOption = _ref.linkPickerOptions,
    linkPickerOptions = _ref$linkPickerOption === void 0 ? {} : _ref$linkPickerOption,
    onSubmit = _ref.onSubmit,
    displayText = _ref.displayText,
    displayUrl = _ref.displayUrl,
    providerFactory = _ref.providerFactory,
    view = _ref.view,
    onCancel = _ref.onCancel,
    invokeMethod = _ref.invokeMethod,
    featureFlags = _ref.featureFlags,
    onClose = _ref.onClose,
    onEscapeCallback = _ref.onEscapeCallback,
    onClickAwayCallback = _ref.onClickAwayCallback,
    pluginInjectionApi = _ref.pluginInjectionApi;
  var _useSharedPluginState = useSharedPluginState(pluginInjectionApi, ['hyperlink']),
    hyperlinkState = _useSharedPluginState.hyperlinkState;
  return /*#__PURE__*/React.createElement(HyperlinkToolbar, {
    linkPickerOptions: linkPickerOptions,
    onSubmit: onSubmit,
    displayText: displayText,
    displayUrl: displayUrl,
    providerFactory: providerFactory,
    view: view,
    onCancel: onCancel,
    invokeMethod: invokeMethod,
    featureFlags: featureFlags,
    onClose: onClose,
    onEscapeCallback: onEscapeCallback,
    onClickAwayCallback: onClickAwayCallback,
    hyperlinkPluginState: hyperlinkState
  });
}

// eslint-disable-next-line @repo/internal/react/no-class-components
export var EditLinkToolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(EditLinkToolbar, _React$Component);
  var _super = _createSuper(EditLinkToolbar);
  function EditLinkToolbar() {
    _classCallCheck(this, EditLinkToolbar);
    return _super.apply(this, arguments);
  }
  _createClass(EditLinkToolbar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.node !== this.props.node) {
        this.hideLinkToolbar();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hideLinkToolbar();
    }
  }, {
    key: "hideLinkToolbar",
    value: function hideLinkToolbar() {
      var view = this.props.view;
      view.dispatch(_hideLinkToolbar(view.state.tr));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        linkPickerOptions = _this$props.linkPickerOptions,
        providerFactory = _this$props.providerFactory,
        url = _this$props.url,
        text = _this$props.text,
        view = _this$props.view,
        featureFlags = _this$props.featureFlags,
        _onSubmit = _this$props.onSubmit,
        pluginInjectionApi = _this$props.pluginInjectionApi,
        forceFocusSelector = _this$props.forceFocusSelector;
      return /*#__PURE__*/React.createElement(HyperlinkAddToolbarWithState, {
        pluginInjectionApi: pluginInjectionApi,
        view: view,
        linkPickerOptions: linkPickerOptions,
        providerFactory: providerFactory,
        displayUrl: url,
        displayText: text
        // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
        // via the floating toolbar
        ,
        invokeMethod: INPUT_METHOD.FLOATING_TB,
        featureFlags: featureFlags,
        onSubmit: function onSubmit(href, title, displayText, inputMethod, analytic) {
          _this.hideLinkToolbar();
          if (_onSubmit) {
            _onSubmit(href, displayText || title, inputMethod, analytic);
          }
        },
        onEscapeCallback: function onEscapeCallback(state, dispatch) {
          var tr = state.tr;
          pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.hyperlink.actions.hideLinkToolbar(tr);
          _hideLinkToolbar(tr);
          forceFocusSelector === null || forceFocusSelector === void 0 ? void 0 : forceFocusSelector("[aria-label=\"".concat(linkToolbarMessages.editLink.defaultMessage, "\"]"))(tr);
          if (dispatch) {
            dispatch(tr);
            return true;
          }
          return false;
        },
        onClickAwayCallback: function onClickAwayCallback(state, dispatch) {
          var tr = state.tr;
          pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.hyperlink.actions.hideLinkToolbar(tr);
          if (dispatch) {
            dispatch(tr);
            return true;
          }
          return false;
        }
      });
    }
  }]);
  return EditLinkToolbar;
}(React.Component);
export var editLink = function editLink(editorAnalyticsApi) {
  return function (state, dispatch) {
    var type = 'hyperlink';
    if (state.selection instanceof NodeSelection) {
      type = state.selection.node.type.name;
    }
    if (dispatch) {
      var tr = state.tr;
      showLinkToolbar(tr);
      editorAnalyticsApi === null || editorAnalyticsApi === void 0 ? void 0 : editorAnalyticsApi.attachAnalyticsEvent(buildEditLinkPayload(type))(tr);
      dispatch(tr);
      return true;
    }
    return false;
  };
};
export var buildEditLinkToolbar = function buildEditLinkToolbar(_ref2) {
  var providerFactory = _ref2.providerFactory,
    node = _ref2.node,
    linkPicker = _ref2.linkPicker,
    featureFlags = _ref2.featureFlags,
    pluginInjectionApi = _ref2.pluginInjectionApi;
  return {
    type: 'custom',
    disableArrowNavigation: true,
    fallback: [],
    render: function render(view, idx) {
      var _pluginInjectionApi$f;
      if (!view || !providerFactory) {
        return null;
      }
      var displayInfo = displayInfoForCard(node, findCardInfo(view.state));
      return /*#__PURE__*/React.createElement(EditLinkToolbar, {
        pluginInjectionApi: pluginInjectionApi,
        key: idx,
        view: view,
        linkPickerOptions: linkPicker,
        providerFactory: providerFactory,
        url: displayInfo.url,
        text: displayInfo.title || '',
        node: node,
        featureFlags: featureFlags,
        forceFocusSelector: pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : (_pluginInjectionApi$f = pluginInjectionApi.floatingToolbar.actions) === null || _pluginInjectionApi$f === void 0 ? void 0 : _pluginInjectionApi$f.forceFocusSelector,
        onSubmit: function onSubmit(newHref, newText, inputMethod, analytic) {
          var urlChanged = newHref !== displayInfo.url;
          var titleChanged = newText !== displayInfo.title;

          // If the title is changed in a smartlink, convert to standard blue hyperlink
          // (even if the url was also changed) - we don't want to lose the custom title.
          if (titleChanged) {
            var _pluginInjectionApi$a;
            return commandWithMetadata(changeSelectedCardToLink(newText, newHref, undefined, undefined, undefined, pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions), {
              action: ACTION.UPDATED,
              inputMethod: inputMethod,
              sourceEvent: analytic
            })(view.state, view.dispatch);
          }
          if (urlChanged) {
            // If *only* the url is changed in a smart link, reresolve
            return updateCard(newHref, analytic)(view.state, view.dispatch);
          }
        }
      });
    }
  };
};
export var editLinkToolbarConfig = function editLinkToolbarConfig(showLinkingToolbar, lpLinkPicker) {
  return showLinkingToolbar ? {
    height: lpLinkPicker ? LINKPICKER_HEIGHT_IN_PX : RECENT_SEARCH_HEIGHT_IN_PX,
    width: RECENT_SEARCH_WIDTH_IN_PX,
    forcePlacement: true
  } : {};
};
export var editDatasource = function editDatasource(node, editorAnalyticsApi) {
  return function (state, dispatch) {
    var _node$attrs;
    var modalType = getDatasourceType((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.datasource.id);
    if (dispatch && modalType) {
      var tr = state.tr;
      showDatasourceModal(modalType)(tr);
      // editorAnalyticsApi?.attachAnalyticsEvent(
      //   buildEditLinkPayload(
      //     type as
      //       | ACTION_SUBJECT_ID.CARD_INLINE
      //       | ACTION_SUBJECT_ID.CARD_BLOCK
      //       | ACTION_SUBJECT_ID.EMBEDS,
      //   ),
      // )(tr);
      dispatch(tr);
      return true;
    }
    return false;
  };
};